import "./styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AdminApp } from "./app.tsx";
import { AuthProvider } from "./auth/auth-context.tsx";

const root = document.getElementById("root");
if (!root) throw new Error("root not found");
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AdminApp />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
